// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"b99ddf5c","119":"0077ec80","152":"3f51b183","322":"ec69d00f","502":"5a51ba43","535":"ec69d00f","604":"4f069925","839":"9914a764","899":"0a25b088"}[chunkId] + ".chunk.css";
};